

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PackageRateDetail from './PackageRateDetail'
import * as packageRateAction from '../../../../../actions/packageRateAction';
import * as hotelAction from '../../../../../actions/hotelAction';
import * as rateAction from '../../../../../actions/rateAction';
import * as bookablePackageRateAction from '../../../../../actions/bookablePackageRateAction';
import * as roomTypeAction from '../../../../../actions/roomTypeAction';



const mapStateToProps = state => {
    return {
        packageRateState: state.packageRateReducer,
        hotelState: state.hotelReducer,
        bookablePackageRateState: state.bookablePackageRateReducer,
        rateState: state.rateReducer,
        roomTypeState: state.roomTypeReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPackageRateDetail: (id) => dispatch(packageRateAction.getPackageRateDetail(id)),
        updatePackageRate: (data, id) => dispatch(packageRateAction.updatePackageRate(data, id)),
        createPackageRate: (data) => dispatch(packageRateAction.createPackageRate(data)),
        updatePackageRateTransalte: (id, data) => dispatch(packageRateAction.updatePackageRateTranslate(id, data)),
        createPackageRateTransalte: (id, data) => dispatch(packageRateAction.createPackageRateTranslate(id, data)),
        getPackageRateTranslate: (id) => dispatch(packageRateAction.getPackageRateTranslate(id)),
        getAllHotels: () => dispatch(hotelAction.getAllHotels()),
        getListRates: (filter) => dispatch(rateAction.getListRates(filter)),
        getListAllBookablePackageRates: (hotelId) => dispatch(bookablePackageRateAction.getListAllBookablePackageRates(hotelId)),
        updatePackageRateProduct: (id, data) => dispatch(packageRateAction.updatePackageRateProduct(id, data)),
        createPackageRateProduct: (id, data) => dispatch(packageRateAction.createPackageRateProduct(id, data)),
        getPackageRateProduct: (id) => dispatch(packageRateAction.getPackageRateProduct(id)),
        resetPackageRateDetail: () => dispatch(packageRateAction.resetPackageRateDetail()),
        getAllRoomTypesByHotel: (id) => dispatch(roomTypeAction.getAllRoomTypesByHotel(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PackageRateDetail));